import { StaticImage } from "gatsby-plugin-image";
import React, { useState } from 'react';
import ProductServices from '../../../services/product-services';
import Button from "../../../shared/components/atoms/button/button";
import HeartRating from '../../../shared/components/atoms/heart-rating/heart-rating';
import Toast from '../../../shared/components/atoms/toast/toast';
import { localStorage } from '../../../shared/utils/storage';
import './section-product-qualify.scss';



const SectionProductQualify = ({ contentInfo, rateUser }) => {

    const [qualify, setQualify] = useState(() => {
        if (localStorage.getItem('TOKEN_INFO') !== null) {
            localStorage.removeItem('LIST_QUALIFY')
            return rateUser ? rateUser : 1;
        } else if (localStorage.getItem('LIST_QUALIFY') !== null) {
            var copyList = localStorage.getItem('LIST_QUALIFY')
            var listFiltered = copyList.filter(productCopy => productCopy.cmsId === contentInfo.idDelProducto)
            var AnomQualify = listFiltered.length === 0 ? 0 : listFiltered[listFiltered.length - 1].rateProduct
            return AnomQualify
        } else {
            return rateUser ? rateUser : 1;
        }
    }
    )
    const [loader, setLoader] = useState(false)
    const [activeToast, setActiveToast] = useState(false);


    const handleQualify = () => {
        var payload = {
            idCMS: contentInfo.idDelProducto,
            countryId: process.env.COUNTRY_CODE,
            icuCode: process.env.LOCALE,
            rateProduct: qualify,
        }

        if (localStorage.getItem('TOKEN_INFO') !== null) {
            setLoader(true)
            var config = {
                headers: {
                    Authorization: localStorage.getItem('TOKEN_INFO').idToken,
                }
            }
            ProductServices.qualifyProduct(payload, config).then(res => {
                setLoader(false)
                if (res.status === 200) {
                    setActiveToast({
                        messageToast: "¡Gracias por compartirnos tu experiencia con este producto!",
                        checkToast: true
                    })
                } else {
                    setActiveToast({
                        checkToast: false
                    })
                }
            }).catch(e => console.log(e))
        } else {
            setLoader(true)
            ProductServices.qualifyProduct(payload).then(res => {
                setLoader(false)
                if (res.status === 200) {
                    var dispatch = [payload];

                    if (localStorage.getItem('LIST_QUALIFY') === null) {
                        localStorage.setItem('LIST_QUALIFY', JSON.stringify(dispatch))
                    } else {
                        var copyList = localStorage.getItem('LIST_QUALIFY')
                        var newList = copyList.concat(dispatch)
                        localStorage.setItem('LIST_QUALIFY', JSON.stringify(newList))
                    }
                    setActiveToast({
                        messageToast: "¡Gracias por compartirnos tu experiencia con este producto!",
                        checkToast: true
                    })
                } else {
                    setActiveToast({
                        checkToast: false
                    })
                }
            }).catch(e => console.log(e))
        }
    }


    return (
        <section className="f-m-productQualify" id="f-m-productQualify">
            <div className="f-m-productQualify__content">
                <div className="f-m-productQualify__content-info">
                    <h2 className="f-m-productQualify__content-title">¡Compártenos tu experiencia con este producto!</h2>
                    <p className="f-m-productQualify__content-copy">Elige entre <span>1 y 5</span>  para calificar, siendo 1 la más baja y 5 la más alta.</p>
                    <div className="f-m-productQualify__content-qualify">
                        <HeartRating readOnly={false} rate={qualify} setRateUser={setQualify} />
                    </div>
                    <Button
                        className="f-a-button__primary-blue f-a-button__big"
                        id="f-a-button__product-qualify"
                        onclick={() => handleQualify()}
                        copy={"Enviar calificación"}
                        loader={loader}
                    />
                </div>
                <StaticImage
                    className="f-m-productQualify__content-img"
                    src='./../../../assets/images/calificar.png'
                    alt="imagen Pequeñín calificar producto"
                    placeholder="blurred"
                />
            </div>
            {activeToast && <Toast
                message={activeToast.messageToast ? activeToast.messageToast : null}
                check={activeToast.checkToast ? activeToast.checkToast : null}
                activeToast={activeToast}
                setActiveToast={setActiveToast}
            />}
        </section>
    )
}

export default SectionProductQualify
